import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import HtmlContent from './HtmlContent'

const AccordionSection = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);
  
    const toggleSection = () => {
      setIsOpen(!isOpen);
    };

  

    return (
        <div className='acc-content'>
        <div 
        className='d-flex justify-content-between align-items-center p-2 '
          style={{ 
            cursor: 'pointer' 
          }} 
          onClick={toggleSection}
        >
          <h3>{title}</h3>
          <motion.div
          initial={false}
          animate={{ rotate: isOpen ? 180 : 0 }} // چرخش آیکن
          transition={{ duration: 0.3 }} // مدت زمان انیمیشن
          >
            {isOpen ? <i className='icon-minus-1'></i> : <i className='icon-plus-1'></i>}
          </motion.div>
      
        </div>
        <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }} // حالت اولیه
            animate={{ opacity: 1, height: 'auto' }} // حالت هنگام نمایش
            exit={{ opacity: 0, height: 0 }} // حالت هنگام خروج
            transition={{ duration: 0.3 }} // مدت زمان انیمیشن
            style={{ overflow: 'hidden' }} // برای جلوگیری از مشکلات layout
          >
            <div className='p-2 acc-sub-content'>
              {typeof children === "string" ? <HtmlContent content={children} /> : children}
            </div>
          </motion.div>
        )}
        </AnimatePresence>
        </div>
    );
};
export default AccordionSection;